import { ReleaseType } from '@ibk/shared-types';
export function isConfiguredVoucher(voucher) {
    return (voucher.hasIndividualValue ||
        (voucher.consensusValue ?? 0) > 0 ||
        (voucher.releaseType === ReleaseType.DAILY && (voucher.amountDaily ?? 0) > 0));
}
